import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'
import { PresenterBackground } from '../../../components/VirtualBackgroundPicker/VirtualBackgroundPicker'

/**
 * Returns the presenters background
 * @param state The Redux state
 */

const getBackground = (state: State): PresenterBackground => state.userSettings.presenterBackground

export function presenterBackground (
  background: PresenterBackground
): PresenterBackground {

  return  background

}

export default () => createSelector(
  [getBackground],
  (background): PresenterBackground =>
  presenterBackground(background)
)
